exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".page-next-button{text-align:center;margin:30px 0}.page-next-button__label{font-family:FranklinGothicDemi}.page-next-button__btn{cursor:pointer}.page-next-button__image{font-size:2em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-146e433c","scoped":false,"hasInlineConfig":false}!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/page-next-button/page-next-button.vue
// module id = 51
// module chunks = 0